import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TranslationForm, OptionsForm, WordboxForm, OpenQuestionForm } from '../forms'
import { exerciseTypes } from '../../common/config'
import { createLesson, editLesson, clearLessonDetail } from '../../common/lessons/actions'
import { Button } from '../components'


class ExerciseTestForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      exerciseType: null,
      isOnboarding: false,
    }
    this.hideForm = this.hideForm.bind(this)
  }

  componentDidMount() {
    const { location } = this.props

    if (location.search.includes('type=list')) {
      this.setexerciseType(exerciseTypes.TRANSLATION)
      this.setState({ isOnboarding: true })
    }
  }

  setexerciseType(type) {
    this.setState({
      exerciseType: type,
    })
  }

  clearLesson() {
    this.props.clearLessonDetail()
    this.setexerciseType(null)
  }

  hideForm = () => {
    const { hide, subscribeRedirect } = this.props
    if (this.state.isOnboarding) {
      subscribeRedirect()
    } else {
      hide()
      this.clearLesson()
    }
  }

  render() {
    const { createLesson, editLesson, hide, lesson, intl, subscribeRedirect } = this.props
    let { exerciseType, isOnboarding } = this.state

    if (lesson) {
      exerciseType = lesson.type
    }

    return (
      <div className="popup-wrapper">
        <div className="popup-content">
          <header>
            {
              exerciseType !== null &&
              <div
                className="back-arrow"
                onClick={() => {
                  if (isOnboarding) {
                    hide()
                  } else {
                    this.clearLesson()
                  }
                }}
              >
                <FontAwesomeIcon icon="arrow-left" size="2x" />
              </div>
            }
            {
              !isOnboarding &&
              <div
                onClick={() => hide()}
                className="popup-wrapper-close"
              >
                <FontAwesomeIcon icon="times-circle" size="2x" />
              </div>
            }
          </header>
          <div className="popup-content-body">
            {
              exerciseType === null &&
              <div className="popup-content-options">
                <Button
                  id="popup-options-exercise"
                  className="button"
                  onClick={() => this.setexerciseType(exerciseTypes.OPTIONS)}
                >
                  <img src="/assets/icons/OPTIONS2.png" alt="Options" />
                  {intl.formatMessage(messages.optionsexercise)}
                </Button>
                <Button
                  id="popup-wordbox-exercise"
                  className="button"
                  onClick={() => this.setexerciseType(exerciseTypes.WORDBOX)}
                >
                  <img src="/assets/icons/WORDBOX2.png" alt="Wordbox" />
                  {intl.formatMessage(messages.wordboxexercise)}
                </Button>
                <Button
                  id="popup-translation-exercise"
                  className="button"
                  onClick={() => this.setexerciseType(exerciseTypes.TRANSLATION)}
                >
                  <img src="/assets/icons/TRANSLATION2.png" alt="Translation" />
                  {intl.formatMessage(messages.translationsexercise)}
                </Button>
                <Button
                  id="popup-open-question-exercise"
                  className="button"
                  onClick={() => this.setexerciseType(exerciseTypes.OPEN_QUESTION)}
                >
                  <img src="/assets/icons/TRANSLATION2.png" alt="Open Question" />
                  {intl.formatMessage(messages.openquestionexercise)}
                </Button>
              </div>
            }
            {
              exerciseType === exerciseTypes.TRANSLATION &&
              <TranslationForm
                submitLesson={lesson ? editLesson : createLesson}
                isTestForm
                hideForm={this.hideForm}
                lesson={lesson}
                subscribeRedirect={subscribeRedirect}
              />
            }
            {
              exerciseType === exerciseTypes.WORDBOX &&
              <WordboxForm
                submitLesson={lesson ? editLesson : createLesson}
                isTestForm
                hideForm={this.hideForm}
                lesson={lesson}
              />
            }
            {
              exerciseType === exerciseTypes.OPTIONS &&
              <OptionsForm
                submitLesson={lesson ? editLesson : createLesson}
                isTestForm
                hideForm={this.hideForm}
                lesson={lesson}
              />
            }
            {
              exerciseType === exerciseTypes.OPEN_QUESTION &&
              <OpenQuestionForm
                submitLesson={lesson ? editLesson : createLesson}
                isTestForm
                hideForm={this.hideForm}
                lesson={lesson}
              />
            }
          </div>
        </div>
      </div>
    )
  }
}

ExerciseTestForm.defaultProps = {
  editLesson: null,
  viewer: null,
  lesson: null,
}

ExerciseTestForm.propTypes = {
  intl: PropTypes.object.isRequired,
  createLesson: PropTypes.func.isRequired,
  editLesson: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
  lesson: PropTypes.object,
}

ExerciseTestForm = withRouter(ExerciseTestForm)

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lesson: state.lessons.currentLesson,
  }), { createLesson, editLesson, clearLessonDetail }),
  injectIntl,
)

export default enhance(ExerciseTestForm)

const messages = defineMessages({
  optionsexercise: {
    id: 'exerciseTest.form.optionsexercise',
    defaultMessage: 'Cvičenie na výber možností',
  },
  translationsexercise: {
    id: 'exerciseTest.form.translationsexercise',
    defaultMessage: 'Cvičenie na preklad výrazov',
  },
  wordboxexercise: {
    id: 'exerciseTest.form.wordboxexercise',
    defaultMessage: 'Cvičenie na doplňovanie slov do viet',
  },
  openquestionexercise: {
    id: 'exerciseTest.form.openquestionexercise',
    defaultMessage: 'Cvičenie na otvorené otázky',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/ExerciseTestForm.js